import React from "react";
import classNames from "classnames";
import s from "./Checkbox.module.css";

export const CheckboxVariants = ["primary", "secondary", "map-button"] as const;
interface CheckboxProps {
  label: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
  variant?: (typeof CheckboxVariants)[number];
}

const Checkbox: React.FC<CheckboxProps> = ({
  label,
  checked,
  onChange,
  variant = "primary",
}) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange(e.target.checked);
  };

  const rootClassName = classNames(s.checkbox, {
    [s[variant]]: variant,
  });

  return (
    <label className={rootClassName}>
      <input
        type="checkbox"
        checked={checked}
        onChange={handleChange}
        className={s.checkboxInput}
      />
      <span className={s.checkboxCustom}></span>
      <span className={s.checkboxLabel}>{label}</span>
    </label>
  );
};

export default Checkbox;
